import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, Duration } from 'luxon';

const maxReferenceUnitValues = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'] as const;
const numberSpaceWordRegex = RegExp(/^\d+\s\w+?$/);
type MaxReferenceUnits = typeof maxReferenceUnitValues[number];

@Pipe({ name: 'timeReference' })
export class TimeReferencePipe implements PipeTransform {
	private _maxNum: number;
	private _maxUnit: MaxReferenceUnits;
	private _isbackwards: boolean = true;
	transform(datetime: DateTime, maxReference?: string): string {
		// console.log(
		// 	'AAA',
		// 	datetime.toISO(),
		// 	datetime.diffNow().as('years'),
		// 	// datetime.toRelative({ unit: 'days' }),
		// );
		if (datetime.diffNow().as('years') <= -1) return datetime.toRelative({ unit: 'years' });
		if (datetime.diffNow().as('months') <= -1) return datetime.toRelative({ unit: 'months' });
		if (datetime.diffNow().as('weeks') <= -1) return datetime.toRelative({ unit: 'weeks' });
		if (datetime.diffNow().as('days') <= -1) return datetime.toRelative({ unit: 'days' });
		if (datetime.diffNow().as('hours') <= -1) return datetime.toRelative({ unit: 'hours' });
		if (datetime.diffNow().as('minutes') <= -5) return datetime.toRelative({ unit: 'minutes' });
		if (datetime.diffNow().as('minutes') <= -1) return 'general.time.a_few_min';
		return 'general.time.a_few_sec';
		// return datetime.toRelativeCalendar();

		// if (datetime.invalidReason) {
		// 	return datetime.invalidReason;
		// }
		// const ref = maxReference ?? '1 year';
		// if (!this._matchesRegex(ref))
		// 	console.error(
		// 		`'maxReference' format doesnt match [number][space]['${maxReferenceUnitValues
		// 			.slice()
		// 			.reverse()
		// 			.join("'|'")}'']`,
		// 	);
		// this._isbackwards = this._isTimeBefore(datetime);
		// const valueUnit = ref.split(' ');
		// this._maxNum = parseInt(valueUnit[0]);
		// this._maxUnit = valueUnit[1] as MaxReferenceUnits;
		// return this._parseValue(datetime, this._maxNum, this._maxUnit);
	}

	private _matchesRegex(value?: string) {
		return numberSpaceWordRegex.test(value.trim());
	}

	private _isTimeBefore(datetime: DateTime) {
		return datetime.startOf('day') <= DateTime.now().startOf('day');
	}

	private _parseValue(value: DateTime, maxNum: number, maxUnit: MaxReferenceUnits) {
		const duration: Duration = this._durationBetweenNow(value);

		for (var unit of maxReferenceUnitValues) {
			if (duration[maxUnit] > maxNum) return value.toFormat('DDD');
			if (duration[unit] !== 0)
				if (this._isbackwards)
					return `${this._parseNumber(Math.ceil(duration[unit]), unit)} ${this._formatUnitSingular(
						duration[unit],
						unit,
					)} ago`;
				else
					return `in ${this._parseNumber(Math.ceil(duration[unit]), unit)} ${this._formatUnitSingular(
						duration[unit],
						unit,
					)}`;
		}
		this._parseNumber(duration.seconds, 'seconds');
	}

	private _formatUnitSingular(num: number, unit: string) {
		return num > 1 ? unit : unit.substring(0, unit.length - 1);
	}

	private _parseNumber(num: number, unit: MaxReferenceUnits) {
		const AFew = 'a few';
		switch (unit) {
			case 'seconds':
				if (num < 10) return AFew;
			case 'minutes':
				if (num < 5) return AFew;
			default:
				return num.toString();
		}
	}

	private _durationBetweenNow(enteredDate: DateTime) {
		if (this._isbackwards) return DateTime.now().diff(enteredDate, [...maxReferenceUnitValues]);
		else return enteredDate.diffNow([...maxReferenceUnitValues]);
	}
}
